const SECRET_BASE_API = "https://api.demo.celest.rest/api";
function sequence(...handlers) {
  const length = handlers.length;
  if (!length) return ({ event, resolve }) => resolve(event);
  return ({ event, resolve }) => {
    return apply_handle(0, event, {});
    function apply_handle(i, event2, parent_options) {
      const handle2 = handlers[i];
      return handle2({
        event: event2,
        resolve: (event3, options) => {
          const transformPageChunk = async ({ html, done }) => {
            if (options?.transformPageChunk) {
              html = await options.transformPageChunk({ html, done }) ?? "";
            }
            if (parent_options?.transformPageChunk) {
              html = await parent_options.transformPageChunk({ html, done }) ?? "";
            }
            return html;
          };
          const filterSerializedResponseHeaders = parent_options?.filterSerializedResponseHeaders ?? options?.filterSerializedResponseHeaders;
          const preload = parent_options?.preload ?? options?.preload;
          return i < length - 1 ? apply_handle(i + 1, event3, {
            transformPageChunk,
            filterSerializedResponseHeaders,
            preload
          }) : resolve(event3, { transformPageChunk, filterSerializedResponseHeaders, preload });
        }
      });
    }
  };
}
async function getUser(event) {
  try {
    const response = await event.fetch(`$api/auth/me`, {
      method: "GET",
      headers: event.locals.fetchAuthHeaders
    });
    if (response.ok) {
      return await response.json();
    }
  } catch (e) {
    console.log(e);
    return null;
  }
  return null;
}
const REQUEST_BODY_METHODS = [
  "POST",
  "PUT",
  "PATCH"
];
const linkHeaderLimit = 3700;
const handleAuth = async ({ event, resolve }) => {
  const token = event.url.searchParams.get("token");
  if (token) {
    event.cookies.set("accessToken", token, {
      path: "/",
      maxAge: 60 * 60 * 24 * 7
    });
  }
  const ACCESS_TOKEN = event.cookies.get("accessToken");
  event.locals.fetchAuthHeaders = {
    "Content-Type": "application/json",
    "Cookie": `accessToken=${ACCESS_TOKEN};`,
    "Authorization": `Bearer ${ACCESS_TOKEN}`
  };
  if (ACCESS_TOKEN) {
    const user = await getUser(event);
    if (user && "id" in user) {
      event.locals.user = user;
    }
  }
  const response = await resolve(event);
  const linkHeader = response.headers.get("Link");
  if (linkHeader && linkHeader.length > linkHeaderLimit) {
    response.headers.delete("Link");
  }
  return response;
};
const handle = sequence(
  handleAuth
);
const handleFetch = async ({ request, fetch }) => {
  const isApiRequest = request.url.includes(`$api/`);
  if (isApiRequest) {
    let requestUrl = request.url.split("$api/")[1];
    requestUrl = `${SECRET_BASE_API}/${requestUrl}`;
    const options = {
      method: request.method,
      headers: request.headers,
      cache: request.cache,
      credentials: request.credentials,
      mode: request.mode,
      referrer: request.referrer,
      referrerPolicy: request.referrerPolicy,
      integrity: request.integrity,
      keepalive: request.keepalive,
      signal: request.signal,
      redirect: request.redirect
    };
    if (REQUEST_BODY_METHODS.includes(request.method.toUpperCase())) {
      options["body"] = await request.text();
    }
    return fetch(requestUrl, options);
  }
  return fetch(request);
};
export {
  handle,
  handleFetch
};
//# sourceMappingURL=hooks.server.js.map
